export default {
  booking_confirmation_title: 'Rezervacijos patvirtinimas',
  booking_confirmation_body: 'Dėkoju jums už rezervaciją. Pateikiame toliau nurodytus patvirtinimo duomenis.',
  location: 'Vietovė',
  pickup_location: 'Paėmimo vietovė',
  dropoff_location: 'Pristatymo vietovė',
  vehicle: 'Transporto priemonė',
  pickup_and_dropoff: 'Paėmimas ir pristatymas (vietinis laikas)',
  distance_allowance: 'Atstumo nuolaida',
  view_voucher: 'Peržiūrėti kuponus',
  view_more_bookings: 'Peržiūrėti daugiau rezervacijų',
  identity_verification_body: 'Turėsite patvirtinti savo tapatybę, prieš paimdami transporto priemonę',
  identity_verification_title: 'Patikrinti tapatybę',
  search_again: 'Ieškoti dar kartą',
  aircon: '„aircon“',
  not_available: 'Važiuoti &amp; „Go“ šiuo metu prieinamas tik nustatytos tapatybės asmenims ir vairuotojo pažymėjimams iš {profiles}, bet visada pridedame daugiau šalių.',
  check_if_included: 'Patikrinkite, kad jūsų šalis įtraukta.',
  included_in_booking: 'Įtraukta į šią rezervaciją',
  cdw_with_excess: 'CDW su pertekliumi',
  theft_protection: 'Apsauga nuo vagysčių su pertekliumi',
  risk_reduction: 'Rizikos sumažinimas',
  free_extras: 'Turite teisę dviem nemokamiems papildomiems <br /> šia rezervacija.',
  total_cost: 'Bendroji nuomos suma',
  continue: 'Tęsti',
  luggage_large_short_label: 'L',
  luggage_medium_short_label: 'M',
  luggage_small_short_label: 'S',
  luggage_large_long_label: 'didelis',
  luggage_medium_long_label: 'vidutinis',
  luggage_small_long_label: 'mažas',
  fuel_unspecified_label: 'nenurodytas',
  transmission_manual_label: 'Rankinis',
  transmission_automatic_label: 'Automatinis',
  make_a_booking: 'Rezervuoti',
  pickup_date: 'Paėmimo data',
  dropoff_date: 'Pristatymo data',
  driver_age: 'Vairuotojas nuo 30 - 65',
  enter_driver_age: 'Prašome įvesti vairuotojo amžių',
  promo_code: 'Akcijos kodas',
  search: 'Paieška',
  dropoff_date_cannot_be_before_pickup_date: 'Pristatymo diena negali būti ankstesnė nei paėmimo data',
  pickup_date_cannot_be_in_the_past: 'Paėmimo data negali būti praeityje',
  pickup_time_cannot_be_in_the_past: 'Paėmimo laikas negali būti praeityje',
  dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'Pristatymo laikas turi būti vėlesnis nei paėmimo laikas tą pačią dieną',
  vehicle_filters: 'Transporto priemonių filtras',
  reset: 'Nustatyti iš naujo',
  transmission: 'Perdavimas',
  all: 'Visa',
  manual: 'Rankinis',
  auto: 'Auto',
  passengers: 'Keleiviai',
  vehicle_type: 'Transporto priemonės markė',
  filter: 'Filtras',
  vehicle_search: 'Transporto priemonės ieška',
  edit: 'Redaguoti',
  no_results: 'Jokie rezultatai neatitinka jūsų filtro kriterijų.',
  small_cars: 'Maži automobiliai',
  medium_cars: 'Vidutiniai automobiliai ',
  large_cars: 'Dideli automobiliai',
  estate_cars: 'Universalai',
  suvs: 'SUV',
  mpvs: 'MPV',
  vans: 'Furgonai',
  camper_vans: 'Namai ant ratų',
  premium: '„Premium“',
  unspecified: 'nenurodytas',
  large: 'didelis',
  medium: 'vidutinis',
  small: 'mažas',
  automatic: 'automatinis',
  you_have_been_refunded: 'Jums buvo grąžinta',
  please_customer_service: 'Norėdami rezervuoti, prašome kreiptis į klientų aptarnavimo skyrių.',
  contact_customer_service: 'Kreipkitės į klientų aptarnavimo tarnybas',
  booking_failed: 'Jūsų rezervacijos negalima apdoroti šį kartą.',
  summary: 'Santrauka',
  reforestation_and_protection: 'Parenkite miškų atnaujinimo ir tropinių miškų apsaugos programas Kosta Rikoje ',
  cost_of_rental: 'Nuomos išlaidos',
  to_pay_now: 'Mokėti dabar',
  pay_on_arrival: 'Mokėti atvykus',
  greenheart_donation: '„Žaliosios širdies“ auka',
  tc_agreement: 'Perskaičiau ir supratau {0}.',
  tc: '„T&C“',
  receive_offers: 'Norėčiau gauti specialiuosius pasiūlymus el. paštu.',
  donate: 'Taip, norėčiau paaukoti {amount}',
  pay_now: 'Mokėti {amount} dabar',
  driver_details: 'Vairuotojo duomenys',
  complete_driver_details: 'Prašome pildyti vairuotojo duomenis',
  are_you_the_driver: 'Ar esate vairuotojas?',
  have_an_account: 'Ar jau turite paskyrą?',
  login: 'Prisijungti',
  or: 'ar',
  first_name: 'Vairuotojo vardas',
  last_name: 'Vairuotojo pavardė',
  email: 'El. pašto adresas',
  phone_number: 'Mobiliojo telefono numeris',
  unable_to_save_driver_information: 'Negalima išsaugoti vairuotojo duomenų. Bandykite dar kartą.',
  pay_on_arrival: 'Mokėti atvykus',
  pay_online_now: 'Mokėti internetu dabar',
  day: 'Diena',
  choose_location: 'Pasirinkit vietovę',
  pickup_location: 'Paėmimo vietovė',
  dropoff_location: 'Pristatymo vietovė',
  location_not_found: 'Atsiprašome, neradome jūsų pageidaujamos vietovės.',
  add: 'Pridėti',
  remove: 'Pašalinti',
  free_extra: 'Papildomas nemokamai',
  free: 'NEMOKAMAS!',
  fast_track_notice: 'Šiai paslaugai taikomi dokumento originalo ribojimai. Prieinama asmenims, turintiems dokumentus iš',
  complete_booking: 'Rezervacija baigta',
  choose_card: 'Prašome pasirinkti kortelę ar pridėti naują.',
  add_billing_details: 'Prašome pridėti atsiskaitymo duomenis. ',
  card_number: 'Kortelės numeris',
  card_holder_name: 'Kortelės savininko pavadinimas',
  card_exp: 'MM / MMMM',
  card_cvc: 'CVC',
  save_card: 'Išsaugoti kortelę?',
  amount_charged: 'Iš jūsų kortelės bus nurašyta lėšų',
  payment_confirmation: 'Patvirtinti rezervaciją ir mokėti',
  payment_methods: 'taikomi mokėjimo būdai',
  use_saved_card: 'x naudoti išsaugotą kortelę',
  use_different_card: '+ naudoti kitą kortelę',
  book_now: 'Rezervuoti dabar',
  minimum_age: 'Tik virš {age}',
  excess_liability: 'Draudimo polisas',
  security_deposit: 'Saugos depozitas',
  fuel_policy: 'Kuro politika',
  like_for_like: '„Like for Like“',
  full_to_full: '„Full to Full“',
  miles_per_rental: '{mileage} nemokamos mylios nuomos metu',
  km_per_rental: '{mileage} nemokamos km nuomos metu',
  unlimited: 'Neribotai',
  unlimited_mileage: 'Neribota rida',
  unlimited_mileage_km: 'Neriboti km',
  non_amendable: 'Nepataisoma',
  non_refundable: 'Negrąžinama',
  free_cancellation_until: 'Nemokamas atšaukimas iki',
  cancellation_in_line_with: 'Atšaukimas pagal',
  tcs: 'T&amp;C',
  free_extras_on_collection: 'Du nemokami priedai paėmimo metu',
  glass_and_tyres_covered: 'Stiklas ir padangos įtrauktos ',
  number_of_passengers: 'Keleivių skaičius',
  number_of_bags: 'Krepšių skaičius ',
  fuel_type: 'Kuro rūšis',
  co2: 'CO2',
  aircon: '„Air con“',
  refrigeration: 'šaldymo metu',
  book_type: 'Rezervuoti {type}',
  processing: 'Apdorojama',
  actual_price: 'Faktinė kaina',
  tooltip: 'Kaina ${currencyCode} - sąmata remiantis keitimo kurso, kaina ${currency} privaloma.',
  deposit: 'Depozitas',
  pay_online: 'Mokėti internetu dabar',
  pay_online_without_extras: 'Nuomos kaina',
  extras_on_arrival: 'Papildomai atvykus',
  insurance_on_arrival: 'Rizikos sumažinimas - Mokėti atvykus',
  insurance_online: 'Rizikos sumažinimas - Mokėti dabar',
  extras_online: 'Papildomai mokėti dabar',
  green_heart_donation: '„Žaliosios širdies“ auka',
  aircon_lower: 'oro kond.',
  why_use_drive_and_go: 'Kodėl naudotis „Drive & Go?“',
  straight_to_car: 'Tiesiai prie automobilio',
  no_queues: 'Jokių eilių',
  self_checkout: 'Savipatikra',
  cant_lose_key: 'Negalima pamesti raktelio',
  online_id_check: 'Internetinė ID patikra',
  phone_as_key: 'Telefonas kaip raktelis',
  premiumplus_benefits_includes: '„Premium Plus+“ privalumai taip pat įtraukti',
  book_drive_go: 'Rezervuoti „Drive & Go“',
  duration: 'Trukmė',
  to_pay_on_arrival: 'Mokėti atvykus',
  return_date: 'Grąžinimo data',
  my_profile: null,
  additional_options: 'Papildomos parinktys',
  booking_details: 'Rezervavimo duomenys',
  price_for_x_days: 'Kaina už {qty_of_days} dieną | Kaina už {qty_of_days} dienas',
  cancelled: 'Apšaukta',
  upcoming: 'Artėjantis',
  active: 'Aktyvus',
  drive_and_go: {
    drive_and_go: '„Drive And Go“',
    available_countries: 'Važiuoti &amp; „Go“ šiuo metu prieinamas tik nustatytos tapatybės asmenims ir vairuotojo pažymėjimams iš šių šalių:',
    drive_and_go_today: 'Rezervuokite „Drive & Go“ šiandien!',
    drive_and_go_shortened: '„Drive & Go“',
    why_use_drive_and_go: 'Kodėl naudotis „Drive & Go?“',
    straight_to_car: 'Tiesiai prie automobilio',
    no_queues: 'Jokių eilių',
    self_checkout: 'Savipatikra',
    cannot_lose_the_key: 'Negalima pamesti raktelio',
    online_id_check: 'Internetinė ID patikra',
    phone_as_a_key: 'Telefonas kaip raktelis',
    premium_plus_benefits_also_included: '„Premium Plus+“ privalumai taip pat įtraukti',
    book_drive_and_go: 'Rezervuoti „Drive & Go“'
  },
  my_bookings: "My bookings",
  no_bookings: "No bookings",
  no_bookings_to_display: 'Nerodomos rezervacijos.',
  search_great_car_rental_deals: "Search great car rental deals for your next trip.",
  odometer_at_collection: 'Odometras paėmus',
  fuel_at_collection: 'Kuras paėmus',
  start_check_in: 'Pradėti registraciją',
  start_collection: 'Pradėti paėmimo procedūrą',
  recent_bookings: 'Naujausios rezervacijos',
  damage: {
    updated_damage_report_submitted: 'Buvo pateikta atnaujinta žalos ataskaita. Mūsų klientų aptarnavimo skyriaus darbuotoja(s) susisieks su jumis, jei reikia.',
    add_additional_damage: 'Pridėti papildomą žalą.',
    you_may_report_additional_damage_up_to: 'Jums gali reikėti pranešti apie papildomą žalą per 24 val. po transporto priemonės patikros ',
    specify_damage: 'Nurodyti žalą',
    please_choose_the_area_and_type_of_damage: 'Prašome pasirinkti žalos vietą ir tipą',
    type_of_damage: 'Žalos tipas',
    is_this_more_than_5_cm: 'Ar ji didesnė nei 5 cm?',
    please_take_or_select_a_photo: 'Prašome pateikti ar pasirinkti nuotrauką',
    please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Prašome pateikti nuotrauką, kurioje aiškiai matoma padaryta žala',
    if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' Jei reikia, galite pridėti kitą nuotrauką, pasirinkti piktogramą ir pridėti kitą nuotrauką',
    save_image: 'Išsaugoti vaizdą',
    save_images: 'Išsaugoti vaizdus',
    damage_saved_successfully: 'Žala išsaugota sėkmingai',
    add_photo: 'Pridėti nuotrauką'
  },
  checkout: {
    collect_vehicle: 'Paimti transporto priemonę',
    we_will_let_you_know_the_details: 'Pranešime jums vietą ir kitus duomenis, kad galėtumėte pasiimti išnuomotą transporto priemonę.',
    inspect: 'Apžiūrėti',
    we_will_ask_for_four_photos_from_each_corner: 'Paprašysime pateikti keturias kiekvieno automobilio kampo nuotraukas kartu su bet kokią nauja, dar nenurodyta žala.',
    fuel_and_milage: 'Kuras ir rida',
    you_confirm_the_readings_at_the_start_of_your_hire: 'Turite patvirtinti ridos skaitiklio ir kuro parodymus nuomos pradžioje.',
    sign: 'Pasirašyti',
    sign_the_rental_agreement: 'Pasirašyti nuomos sutartį.',
    away_you_go: 'Važiuokite',
    you_are_free_to_take_to_the_road: 'Galite leistis į kelią!',
    collect_your_vehicle: 'Paimti savo transporto priemonę',
    get_directions: 'Gauti adresą',
    hide_directions: 'Slėpti adresą',
    local_time: 'vietinis laikas',
    tel: 'Tel.',
    getting_to_the_location: 'Nuvykimas į vietą',
    get_vehicle_details: 'Gauti transporto priemonės duomenis',
    view_map: 'Peržiūrėti žemėlapį',
    unlock_vehicle_and_continue: 'Atrakinti transporto priemonę ir tęsti',
    unable_to_connect_to_vehicle: 'Negalima prijungti transporto priemonės',
    we_were_unable_to_connect_to_the_vehicle_please_check: 'Negalėjome prisijungti prie transporto priemonės - prašome patikrinti, kad esate šalia reikiamos transporto priemonės ir bandykite dar kartą.',
    we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Negalėjome rasti rezervuotos transporto priemonės. Prašome bandyti dar kartą vėliau.',
    odometer_and_fuel: 'Ridos skaitiklis ir kuras',
    odometer: 'Ridos skaitiklis',
    please_confirm_the_odometer_and_fuel_readings: 'Prašome patvirtinti ridos skaitiklio ir kuro rodmenis.',
    the_odometer_field_is_required: 'Būtinas ridos skaitiklio laukelis',
    and_must_be_greater_than_the_checkout_odometer: 'ir turi būti didesnis nei patikrintas ridos skaitiklio rodmuo',
    confirm: 'Patvirtinti',
    please_take_a_photo_from_each_corner_of_the_vehicle: 'Prašome nufotografuoti kiekvieną transporto priemonės kampą',
    pre_existing_damage: 'Išankstinė žala',
    no_pre_existing_damage: 'Nėra išankstinės žalos.',
    new_damage: 'Naujoji žala',
    add_additional_damage: 'pridėti papildomą žalą',
    no_new_damage_to_report: 'Nėra naujos registruotinos žalos',
    checkout_complete: 'Patikra baigta',
    start_rental: 'Pradėti nuomos procedūrą',
    congratulations_name_it_is_time_to_take_to_the_road: 'Sveikiname {customer_name} laikas leistis į kelią!',
    we_are_unable_to_complete_your_vehicle_checkout: 'Negalime baigti jūsų transporto priemonės patikros.',
    please_do_the_following: 'Prašome atlikti šiuos veiksmus',
    remove_all_belonging_and_lock_the_vehicle: 'Paimkite visus daiktus ir užrakinkite transporto priemonę.',
    lock_vehicle: 'Užrakinti transporto priemonę',
    once_you_have_contacted_customer_services: 'Kai kreipiatės į klientų aptarnavimo skyrių',
    vehicle_location: 'Transporto priemonės vieta',
    collect_your: 'Pasiimkite savo',
    start_collection: 'Pradėti paėmimo procedūrą',
    from: 'Iš',
    key_in_glove_box: 'jūsų raktas yra pirštinių dėžutėje',

    keyholder: {
      not_detected: 'Raktas nerastas rakto laikiklyje',
      not_detected_please_try_again: 'Įdėkite raktą į rakto laikiklį ir bandykite dar kartą.',

      not_installed: 'Raktų pakabukas neįdiegtas',
      not_installed_please_contact_customer_service: 'Raktų pakabukas neįdiegtas, susisiekite su klientų aptarnavimo tarnyba.',
    },
    keyring: {
      look_up_failed: 'Nepavyko ieškoti raktų',
      look_up_failed_please_contact_customer_service: 'Raktų pakabukas atrodo išblukęs, susisiekite su klientų aptarnavimo tarnyba.',
    },
    key: {
      invalid: 'Raktas neteisingas',
      invalid_please_contact_customer_service: 'Raktas neteisingas, susisiekite su klientų aptarnavimo tarnyba.',

      expired: 'Raktas nebegalioja',
      expired__please_contact_customer_service: 'Jūsų rakto galiojimo laikas pasibaigė, susisiekite su klientų aptarnavimo tarnyba.',
    }
  },
  checkin: {
    tell_us_where_you_have_parked: 'Nurodykite mus, kur pastatėte transporto priemonę.',
    fuel_and_milage: 'Kuras ir rida',
    you_confirm_the_readings_at_the_end_of_your_hire: 'Patvirtinkite ridos skaitiklio ir kuro parodymus nuomos pabaigoje.',
    inspect: 'Apžiūrėti',
    we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: 'Prašysime pateikti keturias kiekvieno transporto priemonės kampo nuotraukas kartu su naująja žala, sukeltą nuomos laikotarpiu.',
    lock: 'Blokuoti',
    check_you_have_left_no_belonging_then_lock_the_vehicle: 'Patikrinkite, kad nepalikote asmeninių daiktų ir užrakinkite transporto priemonę.',
    please_tell_us_where_you_have_parked_the_vehicle: 'Prašome nurodyti, kur pastatėte transporto priemonę',
    once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Kai užrakinsite transporto priemonę, nebegalėsite jos atrakinti dar kartą.',
    name_please_check_you_have_left_no_belongings_then_lock_the_vehicle: '{first_name}, patikrinkite, ar nepalikote jokių daiktų, užrakinkite transporto priemonę ir, jei reikia, grąžinkite fizinį raktą rakto laikikliui.',
    lock_vehicle: 'Užrakinti transporto priemonę',
    complete_check_in: 'Užbaigti registraciją',
    inspection: 'Apžiūra',
    complete_vehicle_check_in: 'Užpildyti transporto priemonės registraciją',
    we_are_unable_to_complete_your_vehicle_check_in: 'Negalime užbaigti jūsų transporto priemonės registracijos.',
    please_contact_customer_services: 'Prašome kreiptis į klientų aptarnavimo skyrių',
    once_you_have_contacted_customer_services: 'Kai kreipiatės į klientų aptarnavimo skyrių'
  },
  rental_agreement: {
    rental_agreement: 'Nuomos sutartis',
    agreement_between: 'Sutartis tarp',
    and: 'ir',
    sign_rental_agreement: 'Pasirašyti nuomos sutartį',
    i_have_read_and_understood_the_terms_and_conditions: 'Perskaičiau ir supratau nuomos sąlygas'
  },
  full_insurance_no_deposit: 'Visas draudimas ir nereikia jokio užstato',
  excess: '{amount} perteklius',
  deposit: '{amount} užstatas',
  included_daily_distance: '{distance} {unit} per dieną',
  miles: 'mylios',
  kilometers: 'kilometrų',
  collection_details_title: 'Informacija apie kolekciją',
  collection_details_not_found: 'Šioje vietoje nėra apibrėžta išsami kolekcijos informacija',
  free_cancellation: 'Nemokamas ATŠAUKIMAS',
  no_deposit: 'Nr Indėlių',
  benefit_from: 'naudos iš',
  for_only_per_day: 'Tik {price} per dieną',
  upgrade_mee: 'UpgradeMee'
}


// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/lt/bookings.js